import { ReactComponent as Facebook } from '../svg/facebook-icon.svg'
import { ReactComponent as Instagram } from '../svg/instagram-icon.svg'
import { ReactComponent as Youtube } from '../svg/youtube-icon.svg'
import { ReactComponent as Pintrest } from '../svg/pinterest-icon.svg'
import { ReactComponent as Twitter } from '../svg/twitter-icon.svg'
import { ReactComponent as Linkedin } from '../svg/linkedin-icon.svg'
import { ReactComponent as Gift } from '../svg/gift.svg'

const igBG = 'linear-gradient(237.26deg, #F7EBFF 0%, #FFF4F9 50%, #FFF6E0 100%)'
const fbBG = '#F5F9FF'
const twitterBG = '#F5F9FF'
const pintrestBG = '#FDECEF'
const linkedinBG = '#0e76a8'
const youtubeBG = '#FFF2F2'

export const presetTemplates = [
  {
    type: 'social',
    title: 'instagram story',
    height: 1920,
    width: 1080,
    background: igBG,
    icon: <Instagram />,
  },
  {
    type: 'social',
    title: 'instagram post',
    height: 1024,
    width: 1024,
    background: igBG,
    icon: <Instagram />,
  },
  {
    type: 'social',
    title: 'facebook post',
    width: 940,
    height: 788,
    background: fbBG,
    icon: <Facebook />,
  },
  {
    type: 'social',
    title: 'facebook cover',
    width: 851,
    height: 315,
    background: fbBG,
    icon: <Facebook />,
  },
  {
    type: 'social',
    title: 'twitter post',
    width: 1024,
    height: 512,
    background: twitterBG,
    icon: <Twitter />,
  },
  {
    type: 'social',
    title: 'Linkedin post',
    width: 1200,
    height: 675,
    background: linkedinBG,
    icon: <Linkedin />,
  },
  {
    type: 'social',
    title: 'pinterest graphic',
    width: 735,
    height: 1102,
    background: pintrestBG,
    icon: <Pintrest />,
  },
  {
    type: 'social',
    title: 'youtube channel art',
    width: 2560,
    height: 1440,
    background: youtubeBG,
    icon: <Youtube />,
  },
]